<template>
  <div class="page-box">
    <Header />

    <!-- Banner 区域 -->
    <!-- Banner 区 -->
    <div class="page-content bg-color-EAF1FA">
      <div class="top-box max-width-1920"
        :style="{ backgroundImage: `url(${require('@/assets/product/ai/ai_service/banner.png')})` }">
        <div class="content-positioning" data-aos="fade-up">
          <div class="title-1">存算大模型一体机</div>
          <div class="title-2">企业级 AI 工作站一体机<br>
            预装完整 AI 软件栈，开箱即用，即插即用</div>
          <div class="title-3" @click="scrollToContact">
            申请试用
          </div>
        </div>
      </div>

    </div>

    <div class="flow-section" data-aos="fade-up">
      <div class="section-title" style="margin-bottom: 10px;">两大产品系列</div>
      <div class="section-subtitle">双系列产品矩阵，覆盖推理加速与工作站场景，满足不同业务需求</div>

      <div
        style="display: flex;flex-direction: row;width: 1200px;justify-content: center;margin: 70px auto;border-bottom: 1px solid gray;">
        <div class="tab-item tab-xw" :class="{ 'active': currentTab === 'xuanwu' }" @click="switchTab('xuanwu')">
        </div>
        <div class="tab-item tab-zs" :class="{ 'active': currentTab === 'zhongshan' }" @click="switchTab('zhongshan')">
        </div>
      </div>

      <div class="section-title" v-if="currentTab == 'xuanwu'" style="margin-bottom: 10px;">玄武系列 产品介绍</div>
      <div class="section-title" v-else style="margin-bottom: 10px;">钟山系列 产品介绍</div>
      <div class="section-subtitle" v-if="currentTab == 'xuanwu'">高性能 AI 推理卡，为智算中心与企业级 AI 应用提供澎湃算力</div>
      <div class="section-subtitle" v-else>企业级 AI 工作站一体机，预装完整 AI 软件栈，即插即用，让 AI 落地更简单。</div>

      <div style="display: flex;flex-direction: row;margin: 30px auto;gap: 20px;width: 1200px;justify-content: center;">
        <div v-for="model in currentModels" :key="model.id" class="f2-btn"
          :class="{ active: currentModel === model.id }" @click="switchModel(model.id)">
          {{ model.id }}
        </div>
      </div>

      <div
        style="display: flex;flex-direction: row;width: 1200px;margin: 0 auto;align-items: center;justify-content space-between;">
        <div>
          <div class="f1-index">{{ getCurrentProduct().tag }}</div>
          <div class="f1-title">{{ getCurrentProduct().name }}</div>
          <div class="f1-subtitle">{{ getCurrentProduct().desc }}</div>
          <div class="spec-grid-2x2">
            <div v-for="spec in getCurrentProduct().specs" :key="spec.label" class="spec-item">
              <div class="spec-label">{{ spec.label }}</div>
              <div class="spec-value">{{ spec.value }}</div>
            </div>
          </div>
        </div>
        <div>
          <img class="f1-img" :src="getCurrentProduct().image" />
        </div>
      </div>
    </div>



    <!-- 特性展示区 -->
    <div class="features-section">
      <div class="container">
        <h2 class="section-title">产品特性</h2>
        <div class="features-grid">
          <div class="feature-card" v-if="currentTab === 'zhongshan'">
            <img class="feature-icon" src="@/assets/product/ai/ai_service/icon1.png" />
            <h3 class="feature-name">静音设计</h3>
            <p class="feature-desc">低噪音散热系统，办公环境无干扰</p>
          </div>
          <div class="feature-card" v-if="currentTab === 'zhongshan'">
            <img class="feature-icon" src="@/assets/product/ai/ai_service/icon2.png" />
            <h3 class="feature-name">即插即用</h3>
            <p class="feature-desc">预装完整 AI 软件栈，开箱即用</p>
          </div>
          <div class="feature-card" v-if="currentTab === 'zhongshan'">
            <img class="feature-icon" src="@/assets/product/ai/ai_service/icon3.png" />
            <h3 class="feature-name">数据安全</h3>
            <p class="feature-desc">本地化部署，数据不出企业</p>
          </div>
          <div class="feature-card" v-if="currentTab === 'zhongshan'">
            <img class="feature-icon" src="@/assets/product/ai/ai_service/icon4.png" />
            <h3 class="feature-name">专业支持</h3>
            <p class="feature-desc">7×24 小时技术支持服务</p>
          </div>

          <div class="feature-card" v-if="currentTab === 'xuanwu'">
            <img class="feature-icon" src="@/assets/product/ai/ai_service/icon1.png" />
            <h3 class="feature-name">高性能</h3>
            <p class="feature-desc">单卡 280 TOPS 算力，满足大规模推理需求</p>
          </div>
          <div class="feature-card" v-if="currentTab === 'xuanwu'">
            <img class="feature-icon" src="@/assets/product/ai/ai_service/icon2.png" />
            <h3 class="feature-name">低功耗</h3>
            <p class="feature-desc">75W 低功耗设计，降低运营成本</p>
          </div>
          <div class="feature-card" v-if="currentTab === 'xuanwu'">
            <img class="feature-icon" src="@/assets/product/ai/ai_service/icon3.png" />
            <h3 class="feature-name">易扩展</h3>
            <p class="feature-desc">支持多卡并行，灵活扩展算力</p>
          </div>
          <div class="feature-card" v-if="currentTab === 'xuanwu'">
            <img class="feature-icon" src="@/assets/product/ai/ai_service/icon4.png" />
            <h3 class="feature-name">国产化</h3>
            <p class="feature-desc">自主可控，安全可靠</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术参数区 -->
    <div class="specs-section">
      <div class="container">
        <h2 class="section-title">技术规格对比</h2>
        <div class="specs-table">
          <table>
            <thead>
              <tr>
                <th>参数</th>
                <th v-for="model in currentModels" :key="model.id">{{ model.name }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in getCurrentSpecs()" :key="row.label">
                <td class="param-name">{{ row.label }}</td>
                <td v-for="model in currentModels" :key="model.id">{{ row.values[model.id] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <!-- 底部联系方式 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

const VALID_TABS = ['xuanwu', 'zhongshan']
const DEFAULT_TAB = 'xuanwu'

export default {
  metaInfo: metaInfo.aiServer,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      currentTab: 'xuanwu',
      hoverIndex: 0,
      currentModel: 'K300',

      // 产品数据
      products: {
        zhongshan: [
          {
            id: 'H300',
            name: '钟山工作站版 H300',
            tag: "01",
            desc: '面向小微企业的入门级 AI 工作站，满足基础 AI 应用需求，性价比之选。',
            image: require('@/assets/product/ai/ai_service/zs1.png'),
            specs: [
              { label: 'CPU', value: 'TF7140 (40 核)' },
              { label: 'GPU', value: '沐曦 MXC500 × 4 卡' },
              { label: '内存', value: 'DDR4 256GB' },
              { label: '存储', value: '2TB NVMe SSD' }
            ]
          },
          {
            id: 'H500B',
            name: '钟山专业版 H500B',
            tag: "02",
            desc: '面向中小型企业的专业级 AI 工作站，支持行业模型本地化微调。',
            image: require('@/assets/product/ai/ai_service/zs2.png'),
            specs: [
              { label: 'CPU', value: 'TF7180A × 2 颗 (80 核)' },
              { label: 'GPU', value: '沐曦 C500 × 2 卡' },
              { label: '内存', value: 'DDR4 1TB' },
              { label: '存储', value: '4TB NVMe SSD' }
            ]
          },
          {
            id: 'H800B',
            name: '钟山企业版 H800B',
            tag: "03",
            desc: '面向大型企业的高性能 AI 工作站，支持智算中心搭建。',
            image: require('@/assets/product/ai/ai_service/zs3.png'),
            specs: [
              { label: 'CPU', value: 'TF7140 (40 核)' },
              { label: 'GPU', value: '沐曦 C500 × 4 卡' },
              { label: '内存', value: 'DDR4 512GB' },
              { label: '存储', value: '8TB NVMe SSD' }
            ]
          }
        ],
        xuanwu: [
          {
            id: 'K300',
            name: '玄武推理卡 K300',
            tag: "01",
            desc: '面向小微企业的入门级推理卡，高性价比的 AI 算力解决方案。',
            image: require('@/assets/product/ai/ai_service/xw1.png'),
            specs: [
              { label: '单卡算力', value: '280 TOPS INT8' },
              { label: '内存', value: 'DDR4 96G/48GB' },
              { label: '视频解码', value: '32 路 4K' },
              { label: '功耗', value: '75W' }
            ]
          },
          {
            id: 'H500A',
            name: '玄武专业版 H500A',
            tag: "02",
            desc: '面向中小型企业的专业级推理服务器，支持多卡并行。',
            image: require('@/assets/product/ai/ai_service/xw2.png'),
            specs: [
              { label: 'CPU', value: '鲲鹏 920 × 1 颗' },
              { label: 'NPU', value: 'K300 × 3 卡 (420 TOPS)' },
              { label: '内存', value: '512GB' },
              { label: '存储', value: '2TB NVMe SSD' }
            ]
          },
          {
            id: 'H800A',
            name: '玄武企业版 H800A',
            tag: "03",
            desc: '面向大型企业的高性能智算服务器，支持大规模 AI 推理。',
            image: require('@/assets/product/ai/ai_service/xw3.png'),
            specs: [
              { label: 'CPU', value: '鲲鹏 920 × 4 颗' },
              { label: 'NPU', value: 'K300 × 8 卡' },
              { label: '内存', value: '标配 1T/最大 2T' },
              { label: '存储', value: '8TB NVMe SSD' }
            ]
          }
        ]
      },

      // 技术规格数据
      specsData: {
        zhongshan: [
          { label: 'CPU', values: { H300: 'TF7140 (40 核)', H500B: 'TF7180A × 2 (80 核)', H800B: 'TF7140 (40 核)' } },
          { label: 'GPU', values: { H300: '沐曦 MXC500 × 4', H500B: '沐曦 C500 × 2', H800B: '沐曦 C500 × 4' } },
          { label: '内存', values: { H300: 'DDR4 256GB', H500B: 'DDR4 1TB', H800B: 'DDR4 512GB' } },
          { label: '存储', values: { H300: '2TB NVMe SSD', H500B: '4TB NVMe SSD', H800B: '8TB NVMe SSD' } },
          { label: '网络', values: { H300: '双万兆网口', H500B: '双万兆网口', H800B: '双万兆网口' } },
          { label: '电源', values: { H300: '1200W', H500B: '1600W', H800B: '2000W' } }
        ],
        xuanwu: [
          { label: '单卡算力', values: { K300: '280 TOPS INT8', H500A: '420 TOPS INT8', H800A: '2240 TOPS INT8' } },
          { label: 'CPU', values: { K300: '-', H500A: '鲲鹏 920 × 1', H800A: '鲲鹏 920 × 4' } },
          { label: 'NPU', values: { K300: '1 卡', H500A: 'K300 × 3', H800A: 'K300 × 8' } },
          { label: '内存', values: { K300: 'DDR4 96G/48GB', H500A: '512GB', H800A: '1TB-2TB' } },
          { label: '视频解码', values: { K300: '32 路 4K', H500A: '96 路 4K', H800A: '256 路 4K' } },
          { label: '功耗', values: { K300: '75W', H500A: '450W', H800A: '1200W' } }
        ]
      }
    }
  },
  computed: {
    currentModels() {
      return this.products[this.currentTab]
    }
  },
  created() {
    // 首次进入（含新标签页打开）时根据 ?series= 选中对应系列，避免错误 tab 的首屏闪烁
    this.applyTabFromRoute()
  },
  watch: {
    // 已在 ai-server 页面时，从导航切换玄武/钟山会复用组件实例，created 不会再次触发
    '$route.query.series'(newVal) {
      this.applyTabFromRoute(newVal)
    }
  },
  methods: {
    scrollToContact() {
      // 触发 Header 组件中的 openContactUs 事件
      this.$root.$emit('openContactUs', '存算大模型一体机')
    },
    switchTab(tab) {
      const next = VALID_TABS.indexOf(tab) !== -1 ? tab : DEFAULT_TAB
      if (this.currentTab === next) return
      this.currentTab = next
      this.currentModel = this.products[next][0].id
    },
    // 从路由 query.series 读取并应用选中的系列
    applyTabFromRoute(val) {
      const series = val !== undefined ? val : this.$route.query.series
      this.switchTab(series)
    },
    switchModel(modelId) {
      this.currentModel = modelId
    },
    getCurrentProduct() {
      return this.currentModels.find(m => m.id === this.currentModel)
    },
    getCurrentSpecs() {
      return this.specsData[this.currentTab]
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}

.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}

.content-positioning {
  width: 1200px;
  text-align: center;
  padding-top: 100px;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
  text-align: justify;
}

.title-2 {
  font-size: 24px;
  color: #222222;
  line-height: 42px;
  text-align: justify;
  margin-top: 33px;
}

.title-3 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  background: linear-gradient(270deg, #29ABFE 0%, #016BFF 100%);
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
}

/* 页面整体样式 */
.page-box {
  background-color: #fff;
  min-height: 100vh;
}

/* Banner 区域 */
.banner-section {
  position: relative;
  height: 600px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0D9488 0%, #0F766E 100%);
}

.banner-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
  padding: 0 40px;
  max-width: 900px;
}

.banner-title {
  font-size: 60px;
  font-weight: bold;
  margin-bottom: 24px;
  letter-spacing: 2px;
}

.banner-subtitle {
  font-size: 24px;
  margin-bottom: 40px;
  opacity: 0.9;
  line-height: 1.5;
}

.banner-buttons {
  display: flex;
  gap: 24px;
  justify-content: center;
}

/* 导航标签 */
.nav-section {
  background-color: #F4F5FB;
  padding: 20px 0;
}

.nav-tabs {
  display: flex;
  justify-content: center;
  gap: 40px;
}

.nav-tab {
  padding: 16px 40px;
  font-size: 18px;
  font-weight: 600;
  color: #666;
  background: white;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-tab:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-tab.active {
  background: #0D9488;
  color: white;
  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.3);
}

/* 产品展示区 */
.product-section {
  padding: 80px 0;
  background-color: #F4F5FB;
}

.product-card {
  background: white;
  border-radius: 24px;
  padding: 60px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 60px;
}

.product-info {
  flex: 1;
}

.product-badge {
  display: inline-block;
  padding: 8px 20px;
  background: #E0F2FE;
  color: #0369A1;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 24px;
}

.product-name {
  font-size: 42px;
  font-weight: bold;
  color: #1F2937;
  margin-bottom: 24px;
}

.product-desc {
  font-size: 18px;
  color: #6B7280;
  line-height: 1.6;
  margin-bottom: 40px;
}

.model-selector {
  margin-bottom: 40px;
}

.model-tabs {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.model-tab {
  padding: 12px 28px;
  font-size: 16px;
  font-weight: 500;
  color: #6B7280;
  background: #F3F4F6;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.model-tab:hover {
  border-color: #0D9488;
  color: #0D9488;
}

.model-tab.active {
  background: #0D9488;
  color: white;
  border-color: #0D9488;
}

.product-details {
  margin-bottom: 40px;
}

.detail-header h3 {
  font-size: 24px;
  font-weight: bold;
  color: #1F2937;
  margin-bottom: 12px;
}

.detail-desc {
  font-size: 16px;
  color: #6B7280;
  margin-bottom: 32px;
}

.specs-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.spec-item {
  background: #F9FAFB;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #E5E7EB;
}

.spec-label {
  font-size: 14px;
  color: #6B7280;
  margin-bottom: 8px;
  text-align: start;
}

.spec-value {
  font-size: 18px;
  font-weight: 600;
  color: #1F2937;
  text-align: start;
}

.action-buttons {
  margin-top: 40px;
}

/* 产品图片区 */
.product-image {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-image {
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.main-image:hover {
  transform: scale(1.02);
}

.image-caption {
  margin-top: 16px;
  font-size: 16px;
  color: #6B7280;
}

/* 特性展示区 */
.features-section {
  padding: 80px 0;
  background: white;
}

.flow-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #fff;
}

.section-title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  color: #1F2937;
  margin-bottom: 60px;
}

.section-subtitle {
  font-size: 16px;
  color: #595859;
  line-height: 21px;
  text-align: center;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

/* 选项卡样式 */
.tab-item {
  cursor: pointer;
  margin: 0 30px;
  width: 600px;
  height: 88px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.3s ease;

  // 玄武按钮 - 默认显示普通状态
  &.tab-xw {
    background-image: url('~@/assets/product/ai/ai_service/btn-xw.png');
    background-size: 100% 100%;

    // 选中时显示激活状态
    &.active {
      background-image: url('~@/assets/product/ai/ai_service/btn-xw-sel.png');
    }
  }

  // 展示按钮 - 默认显示普通状态
  &.tab-zs {
    background-image: url('~@/assets/product/ai/ai_service/btn-zs.png');
    background-size: 100% 100%;

    // 选中时显示激活状态
    &.active {
      background-image: url('~@/assets/product/ai/ai_service/btn-zs-sel.png');
    }
  }
}

.feature-card {
  width: 285px;
  height: 200px;
  background: linear-gradient(180deg, #FAFCFF 0%, #ECF2FF 100%);
  border-radius: 6px;
  border: 1px solid #ECF2FF;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  margin-top: 32px;
  margin-bottom: 20px;
  width: 40px;
  height: 40px;
}

.feature-name {
  font-size: 20px;
  font-weight: 600;
  color: #1F2937;
  margin-bottom: 12px;
}

.feature-desc {
  font-size: 14px;
  color: #6B7280;
  line-height: 1.5;
}

/* 技术参数区 */
.specs-section {
  padding: 80px 0;
  background: #F4F5FB;
}

.specs-table {
  overflow-x: auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.specs-table table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.specs-table th {
  padding: 16px 20px;
  background: #F9FAFB;
  font-weight: 600;
  font-size: 14px;
  color: #1F2937;
  text-align: left;
  border-bottom: 1px solid #E5E7EB;
  white-space: nowrap;
  width: 25%;
}

.specs-table td {
  padding: 16px 20px;
  font-size: 14px;
  color: #6B7280;
  border-bottom: 1px solid #E5E7EB;
  white-space: nowrap;
  text-align: left;
}

.param-name {
  font-weight: 600;
  color: #1F2937;
}

/* CTA 区域 */
.cta-section {
  padding: 100px 0;
  background: white;
}

.cta-title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  color: #1F2937;
  margin-bottom: 20px;
}

.cta-desc {
  font-size: 18px;
  text-align: center;
  color: #6B7280;
  margin-bottom: 40px;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 24px;
}

/* 按钮样式 */
.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  background: #0D9488;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 160px;
  height: 50px;
}

.btn-primary:hover {
  background: #0F766E;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.3);
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  background: white;
  color: #0D9488;
  border: 2px solid #0D9488;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 160px;
  height: 50px;
}

.btn-secondary:hover {
  background: #F0FDFA;
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    padding: 0 20px;
  }

  .product-card {
    padding: 40px;
  }
}

@media (max-width: 992px) {
  .banner-title {
    font-size: 48px;
  }

  .banner-subtitle {
    font-size: 20px;
  }

  .banner-buttons {
    flex-direction: column;
    align-items: center;
  }

  .product-card {
    flex-direction: column;
    gap: 40px;
  }

  .product-image {
    margin-top: 20px;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .banner-section {
    height: 500px;
  }

  .banner-title {
    font-size: 36px;
  }

  .banner-subtitle {
    font-size: 18px;
  }

  .nav-tabs {
    gap: 20px;
  }

  .nav-tab {
    padding: 12px 30px;
    font-size: 16px;
  }

  .product-card {
    padding: 30px 20px;
  }

  .product-name {
    font-size: 32px;
  }

  .model-tabs {
    justify-content: center;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .specs-table th:first-child,
  .specs-table td:first-child {
    width: 150px;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .banner-title {
    font-size: 28px;
  }

  .banner-subtitle {
    font-size: 16px;
  }

  .section-title,
  .cta-title {
    font-size: 28px;
  }

  .product-name {
    font-size: 24px;
  }

  .spec-item {
    padding: 16px;
  }

  .specs-table {
    font-size: 12px;
  }

  .specs-table th,
  .specs-table td {
    padding: 12px 16px;
  }
}

.f2-btn {
  width: 220px;
  height: 50px;
  border-radius: 6px;
  border: 1px solid #016BFF;
  color: #016BFF;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.f2-btn.active {
  width: 220px;
  height: 50px;
  background: #016BFF;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
}

.f1-index {
  font-weight: bold;
  font-size: 28px;
  color: #016BFF;
  line-height: 34px;
  text-align: left;
}

.f1-title {
  font-weight: bold;
  font-size: 28px;
  color: #222222;
  line-height: 34px;
  text-align: left;
  margin-top: 10px;
}

.f1-subtitle {
  font-size: 16px;
  color: #595859;
  line-height: 26px;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 30px;

}

.f1-img {
  width: 510px;
  height: 365px;
}

.spec-grid-2x2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  width: 400px;
}
</style>
